<template>
    <div class="about">
        <v-card class="px-4">
            <v-card-title>Contact Us</v-card-title>
            <v-card-text>
                <v-form ref="inquiryForm" lazy-validation>
                    <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="firstName" :rules="[rules.required]" label="First Name" maxlength="20" :outlined="outlined"
                            :rounded="rounded"
                            :clearable="clearable" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="lastName" :rules="[rules.required]" label="Last Name" maxlength="20" :outlined="outlined"
                            :rounded="rounded"
                            :clearable="clearable" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="email" :rules="emailRules" label="E-mail" :outlined="outlined"
                            :rounded="rounded"
                            :clearable="clearable" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea v-model="message" :rules="[rules.required]" label="Message" hint="Explain us how we can help you" :outlined="outlined"
                            :rounded="rounded"
                            :clearable="clearable" required></v-textarea>
                        </v-col>
                    </v-row>
                </v-form>
                <v-btn color="success" @click="submit">submit</v-btn>
                <v-btn @click="clear">clear</v-btn>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import axios from 'axios';
export default {

    name: 'Contact',
    data: () => ({
        outlined: true,
        rounded: true,
        clearable: true,
        firstName: "",
        lastName: "",
        email: "",
        message: "",
        emailRules: [
            v => !!v || "Required",
            v => /.+@.+\..+/.test(v) || "E-mail must be valid"
        ],
        rules: {
            required: value => !!value || "Required.",
            min: v => (v && v.length >= 8) || "Min 8 characters"
        }
    }),
    methods: {
        submit() {
            const baseUrl = '/message/sendMail';
            if (this.$refs.inquiryForm.validate()) {
                console.log(this.message)
                let mail = {
                    firstName: this.firstName,
                    lastName: this.lastName,
                    email: this.email,
                    message: this.message
                };

                console.log("Calling axios");
                axios.post(baseUrl, mail)
                .then(response => {
                    console.log(response);
                    alert('Message successfully sent!');
                    this.$router.push({ name: 'Home' });
                })
                .catch(e => {
                  this.errors.push(e);
                  alert('Failed to send message!');
                  this.$router.go(-1);
                })
            }
            else {
                console.log("Error: could not validate, thus no message sent!")
            }     
        },
        clear() {
            this.firstName = "",
            this.lastName = "",
            this.email = "",
            this.message = "",
            this.$refs.inquiryForm.resetValidation();
        }
    },
}
</script>